var isParagraphOpen = false;
function openBio(element) {
  var elem = $(element);
  $(window).on('resize', function() {
    elem.find(".hidden-paragraph").css("width", elem.parent().innerWidth() + 20);
  })

  //If a different paragraph is already open, and another one is clicked on to open, reset all people
  if(isParagraphOpen && elem.find(".hidden-paragraph").css("display") != "block") {
    isParagraphOpen = false;
    $(".team-member").each(function() {
      $(this).find(".spacer").css({"background": "#f0f0ef", "margin-bottom": "10px"});
      $(this).find(".tab").css({"background": "#f0f0ef", "margin-bottom": "5px"});
      $(this).find(".spacer").show();
      $(this).find(".hidden-paragraph").css("height", "0px");
      //Here. THis needs to be reworked. Likely the if statement below could be changed to be better, use a attribute on the element to figure out if it is opened or closed.
      $(this).find(".hidden-paragraph").hide();
      $(this).find(".preview").show();
      $(this).find(".continue").show();
    });
  }

  toggleElems(elem, ".spacer");
  elem.find(".tab").css("transition", "none");

  //Toggle css changes
  if(elem.find(".hidden-paragraph").css("display") == "block") {
    isParagraphOpen = false;
    elem.find(".spacer").css({"background": "#f0f0ef", "margin-bottom": "10px"});
    elem.find(".tab").css({"background": "#f0f0ef", "margin-bottom": "5px"});
    elem.find(".spacer").toggle();
    elem.find(".hidden-paragraph").css("height", "0px");
  } else {
    //Set the width and left-alignment of the paragraph. Width is the parent .row element + 20 pixels for the -20 margin-left
    //Left is (-(5% of the body + innerWidth of .team-member column) * index) + (20px * index)
    elem.find(".hidden-paragraph").css({width: elem.parent().innerWidth() + 20, left: (-(($('.team').width() * 0.05) + $(".team-member").eq(0).innerWidth()) * elem.index())});

    //If it is the second or third paragraph showing, move it some amount to the left. I'm not sure why it is off
    // if(elem.index() == 2) {
    //   elem.find(".hidden-paragraph").css("left", parseFloat(elem.find(".hidden-paragraph").css("left")) - 6);
    // } else if(elem.index() == 3) {
    //   elem.find(".hidden-paragraph").css("left", parseFloat(elem.find(".hidden-paragraph").css("left")) - 2);
    // }
    
    elem.find(".spacer").css({"background": "white", "position": "relative", "z-index": "1"});
    elem.find(".tab").css({"background": "white", "margin-bottom": "5px",});
    
    //Only toggle the other spacers
    elem.find(".spacer").toggle();

    //Animate
    elem.find('.hidden-paragraph').css({'height': 'auto', 'min-height': '0'});
    var autoHeight = elem.find('.hidden-paragraph').innerHeight();
    elem.find(".hidden-paragraph").height(0).animate({height: autoHeight}, 500, function(){
      elem.find('.hidden-paragraph').css({'height': 'auto'});
    });

    isParagraphOpen = true;
  }

  elem.find(".tab").css("transition", "background .2s ease-in-out");
  elem.find(".hidden-paragraph").toggle();
  elem.find(".preview").toggle();
  elem.find(".continue").toggle();
  // toggleElems(elem, ".preview");
  // toggleElems(elem, ".continue");
}

function toggleElems(elem, className) {
  $(elem).parent().find(className).each(function() {
    $(this).toggle();
  });
}